<script>
export default {
  name: "InnerText",
  functional: true,
  render: function (h, {props, parent, children, listeners, ...args}) {
    const {name, value,showLabel,showValue = true} = props;
    const click = listeners.click;
    return (<div class='sliderInput topInner' onClick={() => click(value)}>
        {name && showLabel && <span class="scence_ctr_span_title">{ name }</span>}
        {showValue &&<div class="button_info"><span>{value}</span></div>}
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";
.sliderInput.topInner {
  margin-top: 10px;
}
</style>
